import React,{ Component } from 'react';
import { ProgressRing } from './Circle';
import styled, { keyframes } from 'styled-components';
import {observer} from 'mobx-react'
import { IndicatorStore } from '../Stores/IndicatorStore';

type Props = {
    colorStart:string
    colorEnd:string
    backgroundColor:string
    indicatorStore:IndicatorStore
}

const Rotate = keyframes`
0% {
    transform:rotate(0deg)
  }
  100% {
    transform:rotate(360deg)
  }

`
interface IBackground{
    backgroundColor:string
}
const Background = styled.div`
  position:absolute;
  display:flex;
  width:100%;
  height:100%;
  background-color:${(props:IBackground)=>props.backgroundColor};
  justify-content:center;
  align-items:center;
  z-index:1000;
  top:0;
  left:0;
`
const Container = styled.div`
    position:absolute;
    display:flex;
    justify-content:center;
    align-items:center;
    animation: ${Rotate} 2s ease infinite;
`
@observer
export class IndicatorComponent extends Component<Props>{
    render(){
        return(  
            this.props.indicatorStore.show &&<Background backgroundColor={this.props.backgroundColor}>
                <Container>
                    <ProgressRing
                        colorStart={this.props.colorStart}
                        colorEnd={this.props.colorEnd}
                    />
                </Container>
            </Background>
        )
    }

    
    
    
    
}